
export function formatWorkTime(time: string) {
  if (time.startsWith('0')) {
    return time.slice(1, 5);
  }

  return time.slice(0, 5);
}
